interface GratimyLogoProps {
  variant?: 'full' | 'light' | 'icon';
  size?: number;
  className?: string;
}

export function GratimyLogo({ variant = 'full', size = 36, className = '' }: GratimyLogoProps) {
  return (
    <span className={`inline-flex items-center ${className}`}>
      <img
        src="/gratimy-logo.webp"
        alt="Gratimy"
        style={{ height: size, width: 'auto', maxHeight: size, objectFit: 'contain', flexShrink: 0, alignSelf: 'center' }}
        draggable={false}
      />
    </span>
  );
}

export default GratimyLogo;
